const ButtonCancel = ({ title = 'Скасувати', disabled = false, handler = null }) => {
  return (
    <button
      onClick={handler}
      disabled={disabled}
      className="btn btn_white btn_cancel"
      type="button"
    >
      {title}
    </button>
  )
}

export default ButtonCancel
